<template>
	<div>
		<div v-if="!mobile">
			<div
				v-if="loading"
				class="v-main d-flex vh-100 justify-content-center align-items-center"
			>
				<v-progress-circular
					indeterminate
					color="primary"
				></v-progress-circular>
			</div>
			<div v-else>

				<div v-if="token && user">
					<component :is="layout">
						<router-view />
					</component>
				</div>
				<v-app v-else>
					<div
						class="v-main d-flex flex-column vh-100 justify-content-center align-items-center"
					>
						<h1 class="bold">Musisz się zalogować</h1>
						Za chwilę nastąpi przekierowanie do strony logowania
						<div class="mt-3">
							<v-btn
								:href="loginUrl"
								>Zaloguj się!</v-btn
							>
						</div>
						<div class="mt-5">
							<v-progress-circular
								indeterminate
							></v-progress-circular>
						</div>
					</div>

				</v-app>


			</div>

			<v-slide-y-reverse-transition>
				<snackbar v-if="snackbar" :snackbar="snackbar" ref="snackbar"/>
			</v-slide-y-reverse-transition>
			<confirm-leave
				v-if="leave.show"
				:url="leave.url"
				@closed="showLeave = false"
			/>

		</div>
		<div v-else class="v-main d-flex vh-100 justify-content-center align-items-center">
			<v-app class="w-100">
				<v-row justify="center">
					<mobile-app-dialog v-if="mobile" />
				</v-row>
			</v-app>
		</div>
	</div>
</template>

<script>
//import axios from 'axios';
import { mapGetters } from "vuex";
import _ from "lodash";
const ConfirmLeave = import("@/components/items/ConfirmLeave.vue");
const MobileAppDialog = import("@/components/MobileAppDialog.vue");
/* eslint-disable */
//import Pusher from "pusher-js";
/* eslint-enable */
//import Echo from "vue-echo";

// import axios from "axios";
/* eslint-disable */
import Pusher from "pusher-js";
/* eslint-disable */
// import Echo from "vue-echo";
import snackbar from '@/components/Snackbar';
export default {
	name: "App",
	components: {
		ConfirmLeave: () => ({
			component: ConfirmLeave,
		}),
		MobileAppDialog: () => ({
			component: MobileAppDialog,
		}),
		snackbar
	},
	data: () => ({
		loading: true,
		loaded: false,
	}),
	computed: {
		...mapGetters({
			user: "auth/user",
			token: "auth/csrfToken",
			leave: "application/leave",
			seenPosts: "wall/seenPosts",
			snackbar: "application/snackbar",
			visible: "application/visible",
			unreadMeta: "notifications/unreadMeta",
			clock: "application/clock",
			blinking: "notifications/blinking",
			savedForLater: "wall/savedForLater",
			mobile: "application/mobile",
			mobileOS: "application/mobileOS",
			activityTimeout: "application/activityTimeout",
			activeUsers: 'application/activeUsers'

		}),
		layout() {
			return this.$route.meta && this.$route.meta.layout
				? `${this.$route.meta.layout}-layout`
				: `default-layout`;
		},
		loginUrl() {
			return process.env.VUE_APP_LOGIN_URL;
		}
	},
	watch: {
		'unreadMeta.total': function(newVal, oldVal) {
			if(newVal > oldVal) {
				this.setTitle();
				if(!this.visible) {
					this.$store.commit('notifications/setBlinking', true);
				}
			}
		},
		visible: function(newVal) {
			if(newVal) {
				this.$store.commit('notifications/setBlinking', false);
			}
			this.setTitle();
		}
	},
	methods: {
		iOS() {
			console.log("USER ANGENT", navigator.userAgent)
			let is =  [
				'iPad Simulator',
				'iPhone Simulator',
				'iPod Simulator',
				'iPad',
				'iPhone',
				'iPod'
			].includes(navigator.platform)

			||  /iPhone|iPad|iPod/i.test(navigator.userAgent)
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document);
			return is;
		},
		setTitle() {
			return setInterval(() => {
				if(!this.visible) {
					if(this.blinking) {
						if(this.clock % 2 == 0 && this.unreadMeta.total > 0) {
							document.title = '(' + this.unreadMeta.total + ') ' + this.$vuetify.lang.t(this.$route.meta.title) + ' - ' + process.env.VUE_APP_NAME;
						}
						else {
							document.title = this.$vuetify.lang.t(this.$route.meta.title) + ' - ' + process.env.VUE_APP_NAME;
						}
					}
					else {
						if(this.unreadMeta.total > 0) {
							document.title = '(' + this.unreadMeta.total + ') ' + this.$vuetify.lang.t(this.$route.meta.title) + ' - ' + process.env.VUE_APP_NAME;
						}
						else {
							document.title = this.$vuetify.lang.t(this.$route.meta.title) + ' - ' + process.env.VUE_APP_NAME;
						}

					}

				}
				else {
					document.title = this.$vuetify.lang.t(this.$route.meta.title) + ' - ' + process.env.VUE_APP_NAME;
				}
			}, 1000)
		},
		connect() {
			this.$echo.connector.pusher.connect();


			this.$echo.private("company." + this.user.company_id)
			.listenForWhisper('typing', (e) => {
				this.$store.dispatch('application/handleWhisper', e);
			})
			.listenForWhisper('ping', (e) => {
				this.$store.dispatch('application/handlePing', e);
			})
			.listen(".post_added", async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.post_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.post_updated', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.poll_answer_added', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.poll_answer_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.poll_answer_user_added', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.poll_answer_user_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.problem_idea_added', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.problem_idea_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.problem_idea_updated', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.reaction_added', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.reaction_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.reaction_updated', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.comment_added', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.comment_removed', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.comment_updated', async(e) => {
				this.$store.dispatch('application/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_read', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_invite_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_join_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_removed_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_leave_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_mute', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_unmute', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_read_messages', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_read_messages', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_ban_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_unban_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_file_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			});

			this.$echo.join("company." + this.user.company_id)
			.here(users => {
				users.forEach(x => {
					this.$store.commit('application/addActiveUser', x);
				})
			})
			.joining(user => {
				this.$store.commit('application/addActiveUser', user);
			})
			.leaving(user => {
				this.$store.commit('application/removeActiveUser', user);
			})


			this.$echo.private("user." + this.user.id)
			.listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', async(e) => {
				this.$store.dispatch('application/handleNotification', {event: e, auth: this.user})
			})
			.listen('.chat_message_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_read', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_reaction_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_added', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_updated', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_invite_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_join_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_removed_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_leave_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_mute', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_unmute', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_read_messages', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_read_messages', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_ban_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_room_unban_user', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			})
			.listen('.chat_message_file_removed', async(e) => {
				this.$store.dispatch('chat/handleEvent', {event: e, auth: this.user})
			});

		},
		closeLeave() {
			this.$store.commit("application/closeLeave");
		},
		async getCsrfCookie() {
			return await this.$store.dispatch("auth/getCsrfCookie");
		},
		async getToken() {
			return await this.$store.dispatch("auth/getCsrfToken");
		},
		async getUser() {
			await this.$store.dispatch("auth/getUser");
		},
		async getUnreadNotifications() {
			await this.$store.dispatch("notifications/getNotifications", {
				watched: 'no'
			})
		},
		onScroll(e) {
			this.$root.$emit("scroll", e);
		},
		async getChatRooms() {
			this.$store.commit('chat/setLoadingRooms', true);
			await this.$store.dispatch('chat/getRooms', {
				type: 'all'
			});
			this.$store.commit('chat/setLoadingRooms', false);
		}
	},
	beforeCreate() {
		this.$vuetify.theme.dark =
			localStorage.getItem("darkmode") === "true" ? true : false;
	},
	async created() {
		document.documentElement.setAttribute('lang', 'pl');
		// if(/Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || this.iOS()){
		// 	this.$store.commit('application/setMobile', true);
		// 	if(this.iOS()) {
		// 		this.$store.commit('application/setMobileOS', 'ios')
		// 	}
		// 	else {
		// 		this.$store.commit('application/setMobileOS', 'android')
		// 	}
		// }
		// else{
		// 	this.$store.commit('application/setMobile', false)
		// }
		this.$store.commit('application/setMobile', false)
		if(!this.mobile) {
			this.loading = true;
			await this.getToken();
			await this.getCsrfCookie();
			await this.getUser();
			this.getChatRooms();
			this.onScroll = _.debounce(this.onScroll, 100);
			if(this.user) {
				setInterval(() => {
					this.$store.commit('application/incrementClock');
					// if(this.clock == 1 || this.clock % this.activityTimeout == 0) {
					// 	this.$echo.private("company." + this.user.company_id).whisper('ping', {
					// 		id: this.user.id,
					// 		name: this.user.name,
					// 		avatar: this.user.avatar
					// 	});
					// 	this.$store.commit('application/clearInactiveUsers')
					// }
				}, 1000)
				// this.$moment.locale(this.user.locale);
				// this.$vuetify.lang.current = this.user.locale;
				this.$moment.locale("pl");
				this.$vuetify.lang.current = "pl";
				await this.connect();
				this.getUnreadNotifications();

				const t = this;
				document.addEventListener("scroll", function (e) {
					if (window.scrollY > 75) {
						document.body.classList.add("scrolled-down");
					} else {
						document.body.classList.remove("scrolled-down");
					}
					t.onScroll(e);
				});
				document.addEventListener("visibilitychange", event => {
					if(document.visibilityState == "visible"){
					this.$store.commit('application/setVisible', true)
					}
					else{
						this.$store.commit('application/setVisible', false)
					}
				})
			}
			else {
				setTimeout(() => {
					window.location.href = process.env.VUE_APP_LOGIN_URL
				}, 3000);
			}
			this.loading = false;
		}
	},
};
</script>
<style lang="scss">
@import "@/scss/app.scss";
.v-main {
	background: #f9f9f9;
}
</style>
